import React, {useEffect, useState} from 'react';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { fetchGalleryData } from '../../../redux/gallery';
import {useDispatch, useSelector} from "react-redux";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import { DeleteForever, Publish } from '@material-ui/icons';
import DeleteConfirm from '../../../components/Dialogs/DeleteConfirm';
import TablePagination from "@material-ui/core/TablePagination";
import { toast } from 'react-toastify';
import actionCreator from '../../../redux/action/actionCreator';
import { DELETE_IMAGE, UPDATE_IMAGE } from '../../../redux/gallery/types';
import { useNavigate } from 'react-router-dom';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import "../../../assets/styles/components/gallery.css";
import { Button } from '@mui/material';
import GridSkeleton from '../../../components/skeletons/gridSkeletons';
import Pagination from "../../../components/pagination/tablePaginationActions";

const PhotosGalleryCard = ({card}) => {
   const navigate = useNavigate();
  const [state, setState] = useState({openDeleteMessage: false})
  const [anchorEl, setAnchorEl] = React.useState(null);
  const deleteImageStore = useSelector(store => store.deleteImageGlobalStore)
  const dispatch = useDispatch();
  

  const onPublish = async(id, status)=>{
    setAnchorEl(null);
    await toast.promise(
      dispatch(
        actionCreator({
          method:"PATCH",
          path:`/api/gallery/photos/${id}`,
          actionType:UPDATE_IMAGE,
          data:{
            status: `${status}ed`
          }
        })
      ),
      {
        pending:`${status}ing an Image`,
        success:`Image ${status}ed successfully`,
        error:`Unable to publish your Image, try again later`
      }
    );
    
  }

  
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpenCloseDeleteModel = (condition) =>{setAnchorEl(null); setState((prevState) => ({...prevState, openDeleteMessage: condition}))};

  const handleDeleteImage = async(id)=>{
    await toast.promise(
      dispatch(
        actionCreator({
          method:"DELETE",
          path:`/api/gallery/photos/${id}`,
          actionType:DELETE_IMAGE,
        })
      ),
      {
        pending:"Deleting Image",
        success: deleteImageStore.message ? deleteImageStore.messaged : "Image successfully deleted",
        error: `Unable to delete Image`
      }
    );
    handleOpenCloseDeleteModel(false);
  }
  const options = [
  {onClick: onPublish, icon: <Publish />, text:card.status === "published" ? "unpublish" :'publish'},
  { onClick:()=> handleOpenCloseDeleteModel(true), icon: <DeleteForever />, text:'delete'}
];

const ITEM_HEIGHT = 48;
  
  return (
    <div onClick={ (event) => event.preventDefault() } key={card.id} style={{position: "relative",zIndex:0,textDecoration:"none", color:"white"}}>
      <div className='card-content'>
        <DeleteConfirm open={state.openDeleteMessage} message="Photo, Kindly note that this action is irreversible" onCancel={()=>handleOpenCloseDeleteModel(false)} onConfirm={()=>handleDeleteImage(card.id)}/>
        <img
          src={`${card.imageUrl}?w=248&fit=crop&auto=format`}
          srcSet={`${card.imageUrl}?w=248&fit=crop&auto=format&dpr=2 2x`}
          alt={card.title}
          style={{height:"100%", width:"100%", objectFit:"cover"}}
          loading="lazy"
        />
        <div className='card_caption' style={{zIndex:2}}>
          <div style={{zIndex:2, paddingLeft:"10px"}}>
            {card.title}
            <p style={{opacity: .6}}>{card.author.name}</p>
          </div>
          <IconButton
              sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
              aria-label={`info about ${card.title}`}
              onClick={()=>navigate(`/gallery/photos/${card.id}/edit`)}
            >
              {/* <InfoIcon /> */}
              <EditIcon sx={{color:"#E00186"}}/>
            </IconButton>
        </div>
      </div>
        <div style={{position:"absolute", top:0, right:0, zIndex:2}}>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              sx={{backgroundColor:"#E00186", padding:0, margin:"3px 3px" }}
              onClick={handleClick}
            >
              <MoreVertIcon sx={{color:"white"}}/>
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button',
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                },
              }}
            >
              {options.map((option, index) => (
                <MenuItem key={index} onClick={() =>option.onClick(card.id, option.text)} sx={{display:"flex", alignItems:"center", zIndex:2}}>
                  <div style={{marginRight:"5px", marginTop:"5px"}}>
                    {option.icon}
                  </div>
                  {option.text}
                </MenuItem>
              ))}
            </Menu>
      </div>
    </div>
          
  );
}

function PhotosGallery() {
   const [page, setPage] = useState(0);
  const [displayResult, setDisplayResult] = useState({
    startIndex: 0,
    endIndex: 6,
    result: [],
    count: 0,
  });
  const galleryPhotoData = useSelector(store => store.galleryGlobalStore);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGalleryData(displayResult.startIndex, displayResult.endIndex));
    setDisplayResult({
      ...displayResult,
      result: galleryPhotoData.data.slice(
        displayResult.startIndex,
        displayResult.endIndex
      ),
      count: galleryPhotoData.pagination.totalDocs,
    });
  }, [
    displayResult.startIndex,
  ]);

  const handleChangePage = (event, newPage) => {
    setDisplayResult((prevState) => ({
      ...prevState,
      startIndex:
        page < newPage ? prevState.startIndex + 6 : prevState.startIndex - 6,
      endIndex:
        page < newPage ? prevState.endIndex + 6 : prevState.endIndex - 6,
    }));

    setPage(newPage);
  };
 
  return (galleryPhotoData.loading ? <GridSkeleton length={6}/> : 
    <>
      <div className='galery_content_container'>
        {galleryPhotoData.data.map(card => (
          <PhotosGalleryCard key={card.id} card={card}/>
      ))}
      
      </div>
          <div style={{width:"100%", display:"flex", justifyContent:"flex-end"}}>
            <TablePagination
              colSpan={2}
              count={displayResult.count || galleryPhotoData.pagination.totalDocs}
              rowsPerPage={6}
              rowsPerPageOptions={[]}
              page={page}
              onPageChange={handleChangePage}
              ActionsComponent={Pagination}
            />
          </div>
    </>
    
  );
}

export default PhotosGallery;